import { render, staticRenderFns } from "./Navagation.vue?vue&type=template&id=f8f894cc&scoped=true"
import script from "./Navagation.vue?vue&type=script&lang=js"
export * from "./Navagation.vue?vue&type=script&lang=js"
import style0 from "./Navagation.vue?vue&type=style&index=0&id=f8f894cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f894cc",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn})
